import { FiatCurrency, KycStatus } from '@/api/common.types';
import { useCreateBuyTxn } from '@/api/queryHooks/useBuyCryptoController';
import { useCheckStatus } from '@/api/queryHooks/useKycController';
import { useBuyCrypto } from '@/store/buyCrypto';
import { useVerifyStore } from '@/store/verify';
import { shallow } from 'zustand/shallow';

export const useCreateNewBuyTx = () => {
  const buyState = useBuyCrypto((state) => state, shallow);
  const [checkId] = useVerifyStore((state) => [state.checkId], shallow);
  const { data: kycStatus } = useCheckStatus();
  const isBiometricRequired = kycStatus?.status === KycStatus.BIOMETRIC_REQUIRED;
  const {
    mutate: getBestPrices,
    data: txData,
    isError: isCreateNewTxError,
    error: createNewTxError,
    isLoading: isCreateNewTxLoading,
  } = useCreateBuyTxn({
    onSuccess(data) {
      buyState.setIsFindingBestPrices(false);
      buyState.setData({ txData: data });
    },
  });

  function createNewTx() {
    buyState.setIsFindingBestPrices(true);
    getBestPrices({
      paymentType: buyState.typeOfPayment,
      cryptoCurrency: buyState.get,
      fiatCurrency: FiatCurrency.AUD,
      fiatAmount: Number(buyState.pay),
      transferAddress: buyState.walletAddress,
      txSource: 'RELAYPAY',
      verificationId: isBiometricRequired ? checkId : undefined,
      cryptoNetwork: buyState.network,
      transferMemo: buyState.memo,
    });
  }

  return { createNewTx, txData, isCreateNewTxError, createNewTxError, isCreateNewTxLoading };
};
